<div class="admin-template-container">
  <markant-nav-drawer
    anchor="left"
    variant="docked"
    [open]="isOpen"
    [toggleText]="'header.navigation_drawer_toggle' | transloco"
    (openChange)="isOpen = !isOpen"
  >
    <markant-nav-item
      slot="header"
      icon="m_checkmark"
      [label]="titleKey | transloco"
    ></markant-nav-item>

    <markant-nav-item
      *ngFor="let item of sidebarItems"
      slot="navItem"
      [id]="'nav-item-' + item.pathKey"
      [extended]="true"
      [routerLink]="item.path"
      [label]="
        'dashboardOverview.navigation.' + item.translationKey + '.label'
          | transloco
      "
      [title]="
        'dashboardOverview.navigation.' + item.translationKey + '.label'
          | transloco
      "
      [active]="item.isActive"
      [icon]="item.icon"
    >
    </markant-nav-item>

    <div slot="app" class="main-content">
      <markant-platform-breadcrumb></markant-platform-breadcrumb>
      <ng-content></ng-content>
    </div>
  </markant-nav-drawer>
</div>
